module.exports = __webpack_public_path__ + "img/image00008.97917acb.jpeg";